module.exports = __webpack_public_path__ + "static/media/cs.c3907175.svg";